<template>
    <div class="page my-history">

        <div class="tags">
            <van-tabs :swipeable="true" v-model="category_id" @click="changeCategory">
                <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in categories" :key="item.type" :title="item.name" ></van-tab>
            </van-tabs>
            <div class="clear"></div>
        </div>
        <div class="course-list-section" style="margin-top: 22px" v-if="type===1">
            <van-row @click="go_detail(item)" v-for="item in course" :key="item.id">
                <div class="course-list-section-box">
                    <div class="course-list-section-left">
                        <img class="course-list-section-left-img" :src="item.cover_img">
                        <img v-if="item.type==2" class="course-list-section-left-zl" src="/static/img/icon_list_tag_column.svg" alt="">
                    </div>
                    <div class="course-list-section-right">
                        <div class="course-list-section-right-title">{{item.title}}</div>
                        <div class="course-list-section-right-author" v-if="item.type != 2">{{item.doctor}} · {{item.hospital}}</div>
                        <div class="course-list-section-right-author" v-else>{{item.course_desc}}</div>
                        <div class="course-list-section-right-detail">{{item.view_count}}人学习</div>
                    </div>
                </div>
            </van-row>
            <van-empty description="没有更多了" v-if="course.length == 0" />
        </div>

        <div class="article-list-section" v-if="type === 2">
            <van-row class="article-list-section-box" @click="$router.push({name:'article-detail',params:{'id':item.id}})" v-for="item in article" :key="item.id">
                <van-col span="8">
                    <img :src="item.cover_img" class="article-list-content-img" alt="">
                </van-col>
                <van-col span="16" class="article-list-content">
                    <div class="article-list-title">{{item.title}}</div>
                    <div class="article-list-content-desc">{{item.desc}}</div>
                    <div class="article-list-content-detail" >
                        <div>
                            {{item.created_at}}
                            <span style="margin-left: 8px">{{item.view_count}}人阅读</span>
                        </div>
                    </div>
                </van-col>
            </van-row>
            <van-empty description="没有更多了" v-if="article.length == 0" />
        </div>
        <van-row class="short-video-list-section" v-if="type===3">
            <div class="short-video-list-box" v-for="(item,index) in short_video" :key="item.id" @click="$router.push({name:'short-video-detail',params:{id:item.id}})">
                <div class="short-video-list-box-img">
                    <van-image
                        fit="cover"
                        :src="item.cover_img"
                        style="width: 100%;height: 100%;border-radius: 6px;"
                    />
                    <div class="short-video-list-box-play-count">
                        <img src="/static/img/video/icon_viedo_watch.svg" alt="">
                        {{item.view_count}}
                    </div>
                </div>
                <div class="short-video-list-box-title">{{item.title}}</div>
            </div>
            <van-empty description="没有更多了" v-if="short_video.length == 0" />
        </van-row>

        <div class="live-list-section" v-if="type == 4">
            <van-row @click="go_live_detail(item)" v-for="item in live" :key="item.id">
                <div class="live-list-section-box">
                    <div class="live-list-section-left">
                        <img class="live-list-section-left-img" :src="item.cover_img">
                        <img v-if="item.type === 2" class="live-list-section-left-zl"
                             src="/static/img/icon_list_tag_column.svg" alt="">
                        <img v-else-if="item.live_status===0" class="live-list-section-left-zl"
                             src="/static/img/live/icon_list_tag_live_count_down.svg" alt="">
                        <img v-else-if="item.live_status===1" class="live-list-section-left-zl"
                             src="/static/img/live/icon_list_tag_live_process.svg" alt="">
                        <img v-else-if="item.live_status>2" class="live-list-section-left-zl"
                             src="/static/img/live/icon_list_tag_live_history.svg" alt="">
                        <div class="live-list-section-left-time" v-if="item.live_status>1"><span>{{item.duration_format}}</span></div>
                    </div>
                    <div class="live-list-section-right">
                        <div class="live-list-section-right-title" v-html="item.title"></div>
                        <div class="live-list-section-right-detail">
                            <!-- <span v-if="item.type === 2">{{item.live_desc}}</span> -->
                            <span v-if="item.live_status < 2">{{item.start_at}}</span>
                            <span v-else>{{item.view_count}}人观看</span>
                            <span class="live-list-section-right-detail-join"
                                  v-if="item.type === 1 && item.live_status===0">预约</span>
                            <span class="live-list-section-right-detail-join"
                                  v-else-if="item.type === 1 && item.live_status===1">加入</span>
                        </div>
                    </div>
                </div>
            </van-row>
            <van-empty description="没有更多了" v-if="live.length == 0" />
        </div>

    </div>
</template>

<script>

    import Interface from "@/util/interface"
    export default {
        name: 'home',
        data() {
            return {
                value: "",
                type:1,
                active: 1,
                banners:[],
                recommend:[],
                articles:[],
                category_id : 0,
                categories:[
                    {name:'课程',type:1},
                    {name:'直播',type:4},
                    {name:'资讯',type:2},
                    {name:'短视频',type:3},
                ],
                list:[],

                course : [],
                article : [],
                short_video : [],
                live : [],
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'course') {
                    Interface.getData('get',Interface.user.history,{type:1,pageSize:999}).then((res)=>{
                        if(res.data.list){
                            this.course = res.data.list
                        }
                    })
                }else if (scene === 'article') {
                    Interface.getData('get',Interface.user.history,{type:2,pageSize:999}).then((res)=>{
                        if(res.data.list){
                            this.article = res.data.list
                        }
                    })
                }else if (scene === 'short-video') {
                    Interface.getData('get',Interface.user.history,{type:3,pageSize:999}).then((res)=>{
                        if(res.data.list){
                            this.short_video = res.data.list
                        }
                    })
                }else if (scene === 'live') {
                    Interface.getData('get',Interface.user.history,{type:4,pageSize:999}).then((res)=>{
                        if(res.data.list){
                            this.live = res.data.list
                        }
                    })
                }
            },
            changeCategory(){
                this.type = this.categories[this.category_id].type
            },
            go_detail(item){
                if (item.type != 2){
                    this.$router.push({'name':'course-detail',params:{id:item.id}})
                }else{
                    this.$router.push({'name':'course-column',params:{id:item.id}})
                }
            },
            go_live_detail(item) {
                if (item.type === 2) {
                    this.$router.push({'name': 'live-column', params: {id: item.id}})
                } else if (item.live_status === 6) {
                    this.$router.push({'name': 'live-detail-home', params: {id: item.id}})
                } else {
                    if (item.live_status === 0) {
                        this.$router.push({'name': 'live-detail', params: {id: item.id}})
                    } else {
                        this.$router.push({'name': 'live-detail-home', params: {id: item.id}})
                    }
                }
            }

        },
        created() {
            this.fetch('course')
            this.fetch('article')
            this.fetch('short-video')
            this.fetch('live')
            Interface.getShareInfo(this,"","","")
        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/my/history/index.vue